import Vue from "vue";
import App from "./App.vue";

import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css";
import "vuesax/dist/vuesax.css";
Vue.use(Vuesax);

import axios from "axios";

import "../themeConfig.js";

import "./globalComponents.js";

import "./assets/scss/main.scss";

import "@/assets/css/main.css";

import "./filters/filters";

import router from "./router";

import store from "./store";

import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

require("./assets/css/iconfont.css");

Vue.config.productionTip = false;

axios.interceptors.request.use(
  (request) => {
    if (localStorage.getItem("token")) {
      request.headers["Authorization"] = `Bearer ${localStorage.getItem(
        "token"
      )}`;
    }
    return request;
  },
  function (error) {
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
